// types

import { createSlice } from "@reduxjs/toolkit";

// initial state
const initialState = {
	deceasedCards: [],
	communityTransferCards: [],
	hospitalCards: [],
	admissionCards: [],
	overallCards: [],
	// Layout state for drag-and-drop
	deceasedLayout: [],
	communityTransferLayout: [],
	hospitalLayout: [],
	admissionLayout: [],
	overallLayout: [],
};

// ==============================|| SLICE - customCard ||============================== //

const customCard = createSlice({
	name: "customCard",
	initialState,
	reducers: {
		setDeceasedCards(state, action) {
			state.deceasedCards = action.payload;
		},
		setOverallCards(state, action) {
			state.overallCards = action.payload;
		},
		setAdmissionCards(state, action) {
			state.admissionCards = action.payload;
		},
		setCommunityTransferCards(state, action) {
			state.communityTransferCards = action.payload;
		},
		setHospitalCards(state, action) {
			state.hospitalCards = action.payload;
		},
		// Layout actions
		setDeceasedLayout(state, action) {
			state.deceasedLayout = action.payload;
		},
		setOverallLayout(state, action) {
			state.overallLayout = action.payload;
		},
		setAdmissionLayout(state, action) {
			state.admissionLayout = action.payload;
		},
		setCommunityTransferLayout(state, action) {
			state.communityTransferLayout = action.payload;
		},
		setHospitalLayout(state, action) {
			state.hospitalLayout = action.payload;
		},
		
	},
});

export const {
	setDeceasedCards,
	setOverallCards,
	setAdmissionCards,
	setCommunityTransferCards,
	setHospitalCards,
	setDeceasedLayout,
	setOverallLayout,
	setAdmissionLayout,
	setCommunityTransferLayout,
	setHospitalLayout,
} = customCard.actions;

export default customCard.reducer;
